<template>
  <div class="comp-root">
    <img
      v-for="index of frameNumber"
      v-show="(index - 1) === currentFrameIdx || (index -1) === (currentFrameIdx - 1)"
      :key="index"
      class="frame"
      :src="`${$publicPath}start-up-frames/开头mg_${(index-1).toString().padStart(4, '0')}.jpg`"
      alt=""
      draggable="false"
      @load="onImgLoad(index - 1)"
      @error="onImgError(index - 1)"
    >
    <van-loading
      v-show="isLoading"
      color="#1989fa"
      class="loading"
      type="spinner"
      size="3rem"
      vertical
    >
      <span style="font-size: 1rem;">
        {{ frameLoadProgress }}
      </span>
    </van-loading>
    <div
      v-if="showLogo"
      class="bottom-wrapper"
    >
      <img
        class="museum-logo"
        src="@/assets/image/museum-logo.png"
        alt=""
        draggable="false"
      >
      <img
        class="our-logo"
        src="@/assets/image/our-logo.png"
        alt=""
        draggable="false"
      >
    </div>
  </div>
</template>

<script>
const frameNumber = 204

export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      frameNumber,
      loadedNumber: 0,
      currentFrameIdx: 0,
      intervalId: null,
      imgStateList: new Array(frameNumber),
      loadCountDown: 100,
      isLoading: true,
      showLogo: false,
    }
  },
  computed: {
    frameLoadProgress() {
      return Math.floor(this.loadedNumber / frameNumber * 100) + '%'
    }
  },
  mounted() {
    this.intervalId = setInterval(() => {
      if (this.frameLoadProgress === '100%') {
      // if ((this.loadCountDown === 0) && (this.imgStateList[this.currentFrameIdx + 1] !== undefined)) {
        this.isLoading = false
        do {
          this.currentFrameIdx++
        } while (this.imgStateList[this.currentFrameIdx] === false)
        if (this.currentFrameIdx >= frameNumber - 50) {
          this.showLogo = true
        }
        if (this.currentFrameIdx >= frameNumber - 1) {
          clearInterval(this.intervalId)
          this.$router.replace({
            name: 'Home'
          })
        }
      } else {
        this.isLoading = true
      }
    }, 41)
  },
  destroyed() {
    clearInterval(this.intervalId)
  },
  methods: {
    onImgLoad(idx) {
      if (idx < 100) {
        this.loadCountDown--
      }
      this.loadedNumber++
      this.imgStateList[idx] = true
    },
    onImgError(idx) {
      if (idx < 100) {
        this.loadCountDown--
      }
      this.loadedNumber++
      this.imgStateList[idx] = false
    }
  }
}
</script>

<style lang="less" scoped>
.comp-root {
  position: absolute;
  height: 100%;
  width: 100%;
}
.frame {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
}
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.bottom-wrapper {
  position: absolute;
  width: 100%;
  bottom: 2.59rem;
  height: 1.36rem;
  display: flex;
  justify-content: center;
  animation: emerge 1s forwards;
  .museum-logo {
    margin-right: 3.58rem;
    flex: 0 0 auto;
    width: 5.17rem;
  }
  .our-logo {
    flex: 0 0 auto;
    width: 4.97rem;
  }
}
@keyframes emerge {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
